import { createSlice } from '@reduxjs/toolkit';
import { UserPrincipalState } from './models';
import { getRootPermissions } from './actions';

const initialState: UserPrincipalState = {
    permissions: [],
    isLoading: false,
    isLoaded: false,
};

const themeSlice = createSlice({
    name: 'userPrincipal',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getRootPermissions.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(getRootPermissions.fulfilled, (state, action) => {
            state.permissions = action.payload;
            state.isLoading = false;
            state.isLoaded = true;
        });
    },
});

export default themeSlice;
